/* eslint-disable react/jsx-fragments */
import React from "react";
import Nav from "reactstrap/lib/Nav";
import NavItem from "reactstrap/lib/NavItem";
import NavLink from "reactstrap/lib/NavLink";
import UncontrolledCollapse from "reactstrap/lib/UncontrolledCollapse";
import ChevronDefaultRight from "@druva-apps/orion-icons/lib/ChevronsmallrightGreyOutline";

import Tooltip from "../components/tooltip";
import Icon from "../components/icon/icon";
import {
  gatherClasses,
  gatherConditionalProps,
  isFunction,
  hasProperty
} from "./utils";

const findElement = index => {
  return new Promise(resolve => {
    const checkExist = setInterval(function findCollapsibleElement() {
      const el = document.querySelector(`#fg-collapse-${index}`);
      if (el && el instanceof HTMLElement) {
        resolve(el);
        clearInterval(checkExist);
      }
    }, 10);
  });
};

export default class SidenavUtils {
  renderSideNav = props => {
    return (
      <React.Fragment>
        {props.items.map((item, index) => {
          if (hasProperty(item, "heading")) {
            return (
              <Nav vertical key={`nav-${index}`} className="oui-mw-100">
                {this.renderHeadingItems(props, item, index)}
              </Nav>
            );
          }

          if (hasProperty(item, "collapsible") && item.collapsible === true) {
            return (
              <Nav vertical key={`nav-${index}`} className="oui-mw-100">
                {this.renderCollapsibleItem(props, item, index)}
              </Nav>
            );
          }

          if (hasProperty(item, "collapsible") && item.collapsible === false) {
            return (
              <Nav vertical key={`nav-${index}`} className="oui-mw-100">
                {this.renderExpandedItem(props, item, index)}
              </Nav>
            );
          }

          if (hasProperty(item, "items")) {
            return (
              <Nav vertical key={`nav-${index}`} className="oui-mw-100">
                {this.renderChildItems(props, item.items, index)}
              </Nav>
            );
          }
          return (
            <Nav vertical key={`nav-${index}`} className="oui-mw-100">
              {this.renderItem(props, item, index)}
            </Nav>
          );
        })}
      </React.Fragment>
    );
  };

  renderItem = (props, item, index, isInnerLink) => {
    if (hasProperty(item, "items") && item.items.length > 0) {
      return this.renderCollapsibleItem(props, item, index, true);
    }
    return (
      <NavItem key={index} className="oui-mw-100">
        {isFunction(item.renderComponent) ? (
          item.renderComponent(
            item,
            index,
            "oui-active",
            isInnerLink ? "oui-nav-link oui-nav-link-inner" : "oui-nav-link"
          )
        ) : (
          <NavLink
            className={gatherClasses(
              null,
              "oui-mw-100",
              item.isActive ? "oui-active" : null,
              isInnerLink ? "oui-nav-link-inner" : null,
              "oui-d-flex oui-justify-content-between oui-align-items-center"
            )}
            onClick={e => {
              if (isFunction(props.onItemClick)) {
                props.onItemClick(item, e);
              }
            }}
            {...gatherConditionalProps(item, "href", "disabled", "target")}
          >
            <Tooltip text={item.name} overflowOnly>
              <div className="oui-text-truncate">
                {item.icon ? (
                  React.isValidElement(item.icon) ? (
                    React.cloneElement(item.icon, {
                      className: gatherClasses(
                        null,
                        "oui-menu-icon",
                        item.icon.props.className
                      )
                    })
                  ) : (
                    <Icon
                      {...item.icon}
                      className={gatherClasses(item.icon, "oui-menu-icon")}
                    />
                  )
                ) : null}
                {item.name}
              </div>
            </Tooltip>
            {isFunction(item.extras) ? (
              <div className="oui-extras oui-d-inline-block oui-ml-2">
                {item.extras()}
              </div>
            ) : null}
          </NavLink>
        )}
      </NavItem>
    );
  };

  renderChildItems = (props, items, index, isInnerLink = false) => {
    return items.map((item, ind) => {
      return this.renderItem(props, item, `${index}-${ind}`, isInnerLink);
    });
  };

  renderHeadingItems = (props, item, index) => {
    return (
      <React.Fragment key={`fg-${index}`}>
        <li className="oui-h6 oui-group-header">{item.heading}</li>
        {this.renderChildItems(props, item.items, index)}
      </React.Fragment>
    );
  };

  renderExpandedItem = (props, item, index) => {
    return (
      <React.Fragment key={`fg-${index}`}>
        <NavItem className="oui-mw-100">
          {isFunction(item.renderComponent) ? (
            item.renderComponent()
          ) : (
            <Tooltip text={item.name} overflowOnly>
              <NavLink
                id={`fg-collapse-${index}`}
                href="#"
                className="oui-mw-100 oui-collapse-trigger-link oui-text-truncate"
              >
                {item.icon ? (
                  React.isValidElement(item.icon) ? (
                    React.cloneElement(item.icon, {
                      className: gatherClasses(
                        null,
                        "oui-menu-icon",
                        item.icon.props.className
                      )
                    })
                  ) : (
                    <Icon
                      {...item.icon}
                      className={gatherClasses(item.icon, "oui-menu-icon")}
                    />
                  )
                ) : null}

                {item.name}
              </NavLink>
            </Tooltip>
          )}
        </NavItem>
        <ul className="oui-collapse-container oui-mw-100">
          {this.renderChildItems(props, item.items, index, true)}
        </ul>
      </React.Fragment>
    );
  };

  renderCollapsibleItem = (props, item, index) => {
    const showExpanded = !!(
      item.items && item.items.find(it => it.isActive === true)
    );

    function toggleClass() {
      const el = document.querySelector(`#fg-collapse-${index}`);
      if (el && el.classList.contains("oui-expanded")) {
        el.classList.remove("oui-expanded");

        if (showExpanded) {
          el.classList.add("oui-active");
        }
      } else {
        el.classList.add("oui-expanded");
        el.classList.remove("oui-active");
      }
    }

    const foundElement = findElement(index);

    if (showExpanded === true) {
      foundElement.then(el => {
        if (!el.classList.contains("oui-expanded")) {
          el.click();
        }
      });
    }

    return (
      <React.Fragment key={`fg-${index}`}>
        <NavItem className="oui-mw-100">
          <NavLink
            id={`fg-collapse-${index}`}
            href="#"
            onClick={toggleClass}
            className="oui-collapse-trigger-link oui-mw-100 oui-d-flex oui-justify-content-between oui-align-items-center"
          >
            <Tooltip text={item.name} overflowOnly>
              <div className="oui-text-truncate">
                {item.icon ? (
                  React.isValidElement(item.icon) ? (
                    React.cloneElement(item.icon, {
                      className: gatherClasses(
                        null,
                        "oui-menu-icon",
                        item.icon.props.className
                      )
                    })
                  ) : (
                    <Icon
                      {...item.icon}
                      className={gatherClasses(item.icon, "oui-menu-icon")}
                    />
                  )
                ) : null}

                {item.name}
              </div>
            </Tooltip>
            <span className="oui-collapse-icon">
              <ChevronDefaultRight inheritFontColor size="md" />
            </span>
          </NavLink>
        </NavItem>
        <UncontrolledCollapse
          tag="li"
          toggler={`#fg-collapse-${index}`}
          className="oui-mw-100"
        >
          <ul className="oui-collapse-container oui-mw-100">
            {this.renderChildItems(props, item.items, index, true)}
          </ul>
        </UncontrolledCollapse>
      </React.Fragment>
    );
  };
}
